export default "__VITE_ASSET__vu_oDh0d__"